/// <reference path="./vite-env.d.ts" />
import { z } from 'zod'

/**
 * Back-office app environment variables
 * Uses Vite's import.meta.env (BACK_ prefix)
 */
export const backOfficeEnvSchema = z.object({
  BACK_API_URL: z.string().url().default('http://localhost:3001'),
})

export type BackOfficeEnv = z.infer<typeof backOfficeEnvSchema>

let _backOfficeEnv: BackOfficeEnv | null = null

export function getBackOfficeEnv(): BackOfficeEnv {
  if (!_backOfficeEnv) {
    _backOfficeEnv = backOfficeEnvSchema.parse(import.meta.env)
  }
  return _backOfficeEnv
}

export const backOfficeEnv = backOfficeEnvSchema.parse(import.meta.env)
